// extracted by mini-css-extract-plugin
module.exports = {"selector":"manual-index-search-widget-simple_selector_1_vxD","button":"manual-index-search-widget-simple_button_2UXwY","input":"manual-index-search-widget-simple_input_3p2XP"};